import React, { useEffect, useState } from "react";
import Layout from "../../../components/Layout";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import ToastFile from "../../../utils/ToastFile";
import { addTask, updateTask } from "../../../api/TaskApi";

const AddUpdateTask = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [isActionEdit, setIsActionEdit] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (state?.task) {
      setIsActionEdit(true);
      reset(state?.task);
    } else {
      setIsActionEdit(false);
    }
  }, []);

  const onSubmit = (data) => {
    let payload = {
      ...data,
      tenant_id: user.tenant_id,
      createdBy: user.user_id,
      createdAt: new Date(),
      modifiedBy: user.user_id,
      modifiedAt: new Date(),
    };
    if (isActionEdit) {
      updateTask(state?.task?._id, payload)
        .then((res) => {
          if (res.status === 200) {
            ToastFile("Task updated successfully", "updated");
            reset();
            navigate("/tasks");
          } else {
            ToastFile("Failed to update task", "error");
          }
        })
        .catch((err) => {
          console.error("Error updating task:", err);
          ToastFile("Error updating task", "error");
        });
      
    } else {
      addTask(payload)
        .then((res) => {
          if (res.status === 201) {
            ToastFile("Task added successfully", "added");
            setTimeout(() => {
              navigate("/tasks");
            }, 2000);
          } else {
            ToastFile("Failed to add task", "error");
          }
        })
        .catch((err) => {
          console.error("Error adding task:", err);
          ToastFile("Error adding task", "error");
        });
    }
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const taskTypeOption = [
    { value: "Delivery", label: "Delivery" },
    { value: "Parcel", label: "Parcel" },
  ];

  return (
    <Layout>
      <div className="p-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3 className="mb-0"> {isActionEdit ? "Edit Task" : "Add Task"}</h3>
        </div>

        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className="mb-3">
            <Form.Label>Task Category</Form.Label>
            <Form.Control
              type="text"
              {...register("category", { required: true })}
              isInvalid={errors.category}
            />
          </Form.Group>
          {/* <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              row={4}
              {...register("description", { required: false })}
              isInvalid={errors.description}
            />
          </Form.Group> */}
          <Form.Group className="mb-3">
            <Form.Label>Work Type</Form.Label>
            <Form.Select
              {...register("workType", { required: true })}
              isInvalid={errors.workType}
            >
              <option value="Todo">Select Task Type</option>
              {taskTypeOption.map((option) => (
                <option key={option.value} value={option.value} selected={option.value ==="Delivery"}>
                  {option.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          {/* <Form.Group className="mb-3">
            <Form.Label>Estimation Hours(optional)</Form.Label>
            <Form.Control
              type="text"
              {...register("estimationHours", { required: false })}
              isInvalid={errors.estimationHours}
            />
          </Form.Group> */}

          <Button variant="primary" type="submit">
            {isActionEdit ? "Update" : "Add"}
          </Button>
          <Button
            variant="white"
            className="border-1 border-dark ms-2"
            onClick={() => navigate("/tasks")}
          >
            Cancel
          </Button>
        </Form>
      </div>
    </Layout>
  );
};

export default AddUpdateTask;
